const groupPrefix = 'authors'

export const apiAuthors = {
	fetchAuthors: async () => {
		const { data } = await apiCommon<IAuthor[]>(groupPrefix, { method: 'GET' })
		if (!data) return []
		return data.map((author) => Author(author))
	},

	createAuthor: async (authorData: Omit<IAuthorModel, 'id'>) => {
		const { data } = await apiCommon<IAuthor>(groupPrefix, { method: 'POST', body: authorToJSON(authorData) })
		return Author(data)
	},

	updateAuthor: async (authorID: number | string, authorData: Omit<IAuthorModel, 'id'>) => {
		const { data } = await apiCommon<IAuthor>(`${groupPrefix}/${authorID}`, { method: 'PUT', body: authorToJSON(authorData) })
		return Author(data)
	},

	deleteAuthor: async (authorID: number | string) => {
		return await apiCommon<string>(`${groupPrefix}/${authorID}`, { method: 'DELETE' })
	},
}
